export class ForecastingParameters {
    usPopulation: number = 1;
    primeMembers: number = 1;
    reachBroad: number = 100000;
    reachNarrow: number = 0;
    frequencyValue: number = 3;
    frequencyInterval: number = 30;
}
